import React from "react";
import { Grid } from "@mui/material";

import Table from "../../subcomponents/Table";
import { formatNumber, formatNumberNull } from "../../../../utils/formats";

const style = {
  width: "16.66%",
  justify: "center",
};

const columns = [
  {
    id: "anoMes",
    name: "Ano/Mês",
    style,
  },
  {
    id: "avencer",
    name: "A Vencer",
    render: formatNumber,
    style,
  },
  {
    id: "vencidoAte",
    name: "Vencido até 90 dias",
    render: formatNumberNull,
    style,
  },
  {
    id: "vencidoMais",
    name: "Vencido +90 dias",
    render: formatNumberNull,
    style,
  },
  {
    id: "prejuizo",
    name: "Prejuízo",
    render: formatNumberNull,
    style,
  },
  {
    id: "limites",
    name: "Limites",
    render: formatNumber,
    style,
  },
];

const FluxoConsolidadoSection = (props) => {
  const { proposalFluxoConsolidadoLoading, proposalFluxoConsolidado } = props;

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Table
            rowHeight={25}
            loadingRows={7}
            noDataMessage="Sem dados."
            columns={columns}
            loading={proposalFluxoConsolidadoLoading}
            entries={proposalFluxoConsolidado}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default FluxoConsolidadoSection;
